var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlSleekArrowRight = function SvgVaknlSleekArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.16 10.52-.53.53-4.6 4.59a.736.736 0 0 1-1.06 0 .765.765 0 0 1-.22-.53.785.785 0 0 1 .22-.53l3.84-3.83H.75a.75.75 0 0 1 0-1.5h17.08l-3.86-3.86a.751.751 0 0 1 1.06-1.06l4.6 4.6.53.53c.29.294.29.766 0 1.06z"
  })));
};
export default SvgVaknlSleekArrowRight;